import { ERROR_SIGNOUT_BUTTON_TEXT } from '../../assets/copy';
import { useHistory } from 'react-router';
import { TextButton } from '../spoon/Button';

const ErrorSignoutButton = () => {
  const history = useHistory();

  return (
    <TextButton onClick={() => history.replace('/sign-out')}>
      {ERROR_SIGNOUT_BUTTON_TEXT}
    </TextButton>
  );
};

export default ErrorSignoutButton;
